(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:stickme
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="commons">
     <file name="index.html">
     <stickme></stickme>
     </file>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('stickme', stickme);

    function stickme($window) {
        return {
            restrict: 'EA',
            replace: false,
            controllerAs: 'stickme',
            controller: function ($scope, $element, $attrs) {
                var vm = this;
                vm.name = 'stickme';


                var stickies = [],
                    offset,
                    target;

                offset = parseInt(($attrs.stickOffset || 0), 10);
                target = $window;

                if ($attrs.stickTargetClass !== undefined || $attrs.stickTargetClass !== ""){
                    target = $("." + $attrs.stickTargetClass);
                }

                $element.addClass($attrs.stickme);

                target.off("scroll.stickies").on("scroll.stickies", function (event) {
                    _whenScrolling(event);
                });

                var _whenScrolling = function(event) {
                    stickies  = angular.element("." + $attrs.stickme);
                    var $scrollTop = $(event.currentTarget).scrollTop();
                    var stickyPositionHeight = 0, $currentSticky;

                    angular.forEach(stickies, function(obj){
                        angular.element(obj).removeClass('top-header');
                    });
                    if ($scrollTop>0){
                        for (var i=0;i<stickies.length;i++){
                            var $thisSticky = angular.element(stickies[i]);
                            stickyPositionHeight = $thisSticky.parent().outerHeight();
                            if( $scrollTop <= (stickyPositionHeight + getPreviousStickyHeight(stickies, i)) - $thisSticky.outerHeight() * 2){
                                $currentSticky = $thisSticky;
                                break;
                            }
                        }

                        if($currentSticky) {
                            $currentSticky.addClass('top-header');
                            $currentSticky.css("top",offset);
                        }
                    }

                };

                var getPreviousStickyHeight = function(stickis, index){
                    var height=0;
                    for (var i=0;i<stickis.length;i++){
                        if(i<index){
                            height +=angular.element(stickis[i]).parent().outerHeight();
                        }
                    }
                    return height
                }

            },
            link: function (scope, element, attrs) {
                /* jshint unused:false */
                /* eslint "no-unused-vars": [2, {"args": "none"}] */
            }
        };
    }
}());
